export enum GuarantorSummaryColumns {
    SummaryItemType = 'summaryItemType',
    BLL = 'bll',
    OutstandingAmount = 'outstandingAmount',
    Surplus = 'surplus',
    RegBLLCapacity = 'regBLLCapacity',
    MaxSurplus = 'maxSurplus',
    Total = 'total',
}
